import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbd50c62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "darkblue" }
const _hoisted_2 = {
  class: "template",
  id: "favorites"
}
const _hoisted_3 = ["data-aos"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardtitle" }, "Speed Grocer", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardsubtitle" }, "iOS & Android Mobile App", -1))
const _hoisted_8 = { class: "link-display" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carddescription" }, "Co-Founded and built a grocery shopping companion app with collaborative list-building and store-specific aisle navigation to help users find their items with ease. No more aimless searching.", -1))
const _hoisted_10 = { class: "flex-row flex-wrap" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_12 = { class: "card" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardtitle" }, "NFLStatUni", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardsubtitle" }, "Website", -1))
const _hoisted_15 = { class: "link-display" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carddescription" }, "Co-Founded - Designed for NFL fanatics by NFL fanatics as a collab to give back. This website takes game data from 2002 to the current year and calculates all sorts of interesting statistics.", -1))
const _hoisted_17 = { class: "flex-row flex-wrap" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_19 = { class: "card" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardtitle" }, "ArborWorks", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardsubtitle" }, "Website", -1))
const _hoisted_22 = { class: "link-display" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carddescription" }, "A website for a client that specializes in tree removal and tree care. This website is designed to guide customers through the process of getting a tree removed with an end goal of asking for a quote for the service.", -1))
const _hoisted_24 = { class: "flex-row flex-wrap" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_26 = { class: "card" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardtitle" }, "TSD Dealer", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardsubtitle" }, "iOS & Android Mobile App", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carddescription" }, "When I was at TSD Rental, I built an app built on a team of 3, to help dealerships get customers in and out of loaner vehicles in a quick and efficient way that ensures all paperwork is completed. This app was a blast to build and had plenty of features. Features include, reservation management, fleet management, barcode and qr scanning, payment processing, PDF signing, and GPS tracking all inside the app.", -1))
const _hoisted_30 = { class: "flex-row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_32 = { class: "card" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardtitle" }, "Fundas", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardsubtitle" }, "iOS & Android App", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carddescription" }, "Using principles from Warren Buffet and Benjamin Graham on value investing this mobile app helps fundamentally analyze companies in seconds. Bringing power and knowledge to the everyday investor by giving them the news that matters most to them and fundamental analysis of any stock publically traded.", -1))
const _hoisted_36 = { class: "flex-row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))

import { useLanguageSwitcher } from '@/composables/useLanguageSwitcher';
import { FadeDown, FadeLeft, FadeRight } from '@/constants/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'Portfolio',
  setup(__props) {

const { t } = useLanguageSwitcher();


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        "data-aos": _unref(FadeDown),
        class: "title"
      }, _toDisplayString(_unref(t)('portfolio.title')), 9, _hoisted_3),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_btn, {
            class: "button mr-3",
            variant: "outlined",
            href: "https://speedgrocer.io"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Website")
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            class: "button mr-3",
            variant: "outlined",
            href: "https://apps.apple.com/us/app/speed-grocer/id6475634115?platform=iphone"
          }, {
            default: _withCtx(() => [
              _createTextVNode("View on iOS")
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            class: "button",
            variant: "outlined",
            href: "https://play.google.com/store/apps/details?id=com.candcventures.speedgrocer&hl=en_US"
          }, {
            default: _withCtx(() => [
              _createTextVNode("View on Android")
            ]),
            _: 1
          })
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Vue3")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Typescript")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Ionic")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Firebase")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Google Maps API")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("EmailJS")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_v_btn, {
            class: "button mr-3",
            variant: "outlined",
            href: "https://nflstatuni.com"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Website")
            ]),
            _: 1
          })
        ]),
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("ReactJS")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("CSS")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("C#")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("HTML Scraping")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Firebase")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("AWS Function")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_v_btn, {
            class: "button mr-3",
            variant: "outlined",
            href: "https://arborworks.co"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Website")
            ]),
            _: 1
          })
        ]),
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Vue3")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("CSS")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Vercel")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Firebase")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _hoisted_28,
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Xamarin")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("C#")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("REST")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("MVVM")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Stripe API")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _hoisted_34,
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Xamarin")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("C#")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("REST")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Firebase")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_37
    ])
  ]))
}
}

})